module.exports = __webpack_public_path__ + "media/images/login-bkg-92eba0f0ff35d9ddc1c55f6a769dd8d9.jpg";